import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';  // Import CommonModule
import { Program } from '../../../interfaces/user.interface';
import { ProgramNameARIALabelPipe } from '../../pipes/program-name-aria-label.pipe';

@Component({
  selector: 'ppl-card',
  standalone: true,
  imports: [CommonModule, ProgramNameARIALabelPipe],  // Include CommonModule in imports
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent {
  programData !: Program;

  @Input() set program(data :any) { 
    this.programData = data;
  };   
  
  @Output() emitSelectedProgram : EventEmitter<Program> = new EventEmitter<Program>();

  selectProgram() {
    this.emitSelectedProgram.emit(this.programData);
  }
  
}
